import { Component, OnInit } from '@angular/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule, } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Clientes } from 'app/interfaces/Cliente';
import { Fazendas } from 'app/interfaces/Fazenda';
import { Operacao, Operacoes, OperacoesDisponiveis } from 'app/interfaces/Operacao';
import { MatSelectModule } from '@angular/material/select';
import { LoadingComponent } from 'app/components/loading/loading.component';
import { DialogService } from 'app/services/dialog/dialog.service';
import { finalize } from 'rxjs';
import { Frentes } from 'app/interfaces/Frente';
import { ClienteService } from 'app/services/cliente/cliente.service';
import { TaxaIdeal, TaxasIdeais } from 'app/interfaces/Taxa-ideal';
import { TaxaIdealService } from '../../../services/taxaIdeal/taxa-ideal.service';
import { OperacaoService } from 'app/services/operacao/operacao.service';
import { Formulario } from 'app/models/formulario.model';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { TAXAS_DISPONIVEIS, TAXAS_SELECT, TaxaDisponivel, TaxaSelect, TipoTaxa } from 'app/constants/taxas.constants';
import { STATUS_OPERACAO_OPTIONS } from 'app/constants/operacao-status.constants';


@Component({
  selector: 'app-taxas-ideais-form',
  standalone: true,
  imports: [
    MatSelectModule,
    MatPaginatorModule,
    ReactiveFormsModule,
    CommonModule,
    LoadingComponent,
    TranslocoModule
  ],
  templateUrl: './taxas-ideais-form.component.html',
  styleUrl: './taxas-ideais-form.component.css'
})
export class TaxasIdeaisFormComponent implements OnInit {
  public operacaoId!: string | null;
  public frentes: Frentes = [];
  public frentesFiltro: Frentes = [];
  public fazendas: Fazendas = [];
  public operacoesDisponiveis!: OperacoesDisponiveis | Operacoes | null;
  public taxasIdeaisCadastradas!: TaxasIdeais;
  public operacao!: Operacao;
  public taxaIdeal!: TaxaIdeal;
  public clienteId!: number;
  public loading: boolean = false;
  public loadingOperacoes: boolean = true;
  public loadingBotao: boolean = false;
  public loadingTaxas: boolean = false;
  public loadingClientes: boolean = true;
  public fazendaPlaceHolder: string = 'Selecione um cliente';
  public placeholderTaxaIdeal: string = 'Selecione uma Taxa ideal';
  public placeholderClientes: string = 'Carregando as usinas...';
  public filtroOperacoes: any = [];
  public pesoMinimoMaiorPesoMax: boolean = false;
  public formularioTaxaIdeal !: FormGroup;
  public botaoDesabilitado: boolean = true;
  public clientes!: Clientes;
  public taxasSelecionadas: any[] = []
  public taxasOperacao: TaxaSelect[] = [];
  public taxasDisponiveis: readonly TaxaDisponivel[] = TAXAS_DISPONIVEIS;
  public taxasSelect = TAXAS_SELECT;
  public taxasDisponivelCadastro: any[] = [];
  public estados = STATUS_OPERACAO_OPTIONS;
  public tiposTaxasSelecionados: string[] = [];
  public valoresIniciais: any;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly formBuilder: FormBuilder,
    private readonly dialogService: DialogService,
    private readonly taxaIdealService: TaxaIdealService,
    private readonly router: Router,
    private readonly clienteService: ClienteService,
    private readonly operacaoService: OperacaoService,
    private readonly translocoService: TranslocoService
  ) { }

  ngOnInit(): void {
    this.obterOperacaoIdDaRota();
    this.construirForm();
    this.onSelectionChangeTiposTaxas();
    this.buscarClientes();
    this.atualizarEstadoBotaoSubmit();
  }

  public onSelectionChangeTiposTaxas(): void {
    this.formularioTaxaIdeal.get('taxas_selecionadas')?.valueChanges.subscribe((taxasSelecionadas: string[]) => {
      this.atualizarTaxasSelecionadas(taxasSelecionadas);
    });
  }

  public onSubmit(): void {
    this.loadingBotao = true;
    if (this.operacaoId) {
      this.atualizar();
    } else {
      this.cadastrar();
    }
  }

  public construirForm(): void {
    this.formularioTaxaIdeal = this.formBuilder.group({
      fk_cliente: [{ value: '', disabled: this.operacaoId !== null }, Validators.required],
      fk_operacao: [this.operacaoId ?? '', Validators.required],
      taxas_selecionadas: ['', Validators.required]
    });
  }

  public buscarClientes(): void {
    this.loading = true;
    this.loadingClientes = true;
    this.loadingOperacoes = true;
    this.loadingTaxas = true;

    this.placeholderClientes = this.translocoService.translate('COMPONENTS.TAXAS_MAPA_FORM.placeholders.loadingClients');

    this.clienteService.buscarClientesUsuario()
      .pipe(finalize(() => {
        this.loadingClientes = false;
        this.loading = false;
      }))
      .subscribe((clientes) => {
        this.clientes = clientes;

        if (clientes.length > 0) {
          this.formularioTaxaIdeal.get('fk_cliente')?.setValue(this.clientes[0].id);
          this.clienteId = this.clientes[0].id;

          this.placeholderClientes = this.translocoService.translate('COMPONENTS.TAXAS_MAPA_FORM.placeholders.selectPlant');
          this.buscarItensCliente();
        } else {
          this.placeholderClientes = this.translocoService.translate('COMPONENTS.TAXAS_MAPA_FORM.placeholders.noPlants');
        }
      });
  }

  public filtrarTaxasJaCadastradas(taxasIdeais: TaxasIdeais): void {
    let tipoTaxas: string[] = taxasIdeais.map(taxa => taxa.en_tipo);
    this.taxasOperacao = this.taxasSelect.filter(taxaIdeal => !tipoTaxas.includes(taxaIdeal.dado));
    this.loadingTaxas = false;
  }

  public buscarOperacoes(): void {
    this.loadingOperacoes = true;
    this.taxasOperacao = [...this.taxasSelect];

    this.clienteService.buscarTodasOperacoes(this.clienteId)
      .pipe(finalize(() => {
        this.loadingOperacoes = false;

        this.buscarTaxasIdeais();
      })).subscribe(
        (operacoes: Operacoes | null) => {
          this.operacoesDisponiveis = operacoes;
        }
      );
  }

  public buscarTaxasIdeais(): void {
    if (!this.operacaoId) {
      return;
    }

    this.loadingOperacoes = true;
    this.loadingTaxas = true;

    this.operacaoService.buscarTaxas(parseInt(this.operacaoId))
      .subscribe(
        (operacao: Operacao) => {
          this.loadingOperacoes = false;
          this.loadingTaxas = false;
          let taxasIdeaisCadastradas: TaxasIdeais = [];

          if (operacao.taxas_ideais) {
            taxasIdeaisCadastradas = operacao.taxas_ideais;
          }

          this.taxasIdeaisCadastradas = taxasIdeaisCadastradas;

          if (taxasIdeaisCadastradas.length > 0) {
            this.formularioTaxaIdeal.get('taxas_selecionadas')?.setValue(taxasIdeaisCadastradas.map((taxaIdeal: TaxaIdeal) => taxaIdeal.en_tipo));
          }
        }
      );
  }

  public atualizarValoresIdeaisEMinimosDosTiposCadastrados(taxasIdeaisCadastradas: TaxaIdeal[]) {
    taxasIdeaisCadastradas.forEach((taxaIdealCadastrada: TaxaIdeal) => {
      this.atualizarValoresPorTaxa(taxaIdealCadastrada)
    });
  }

  public atualizarValoresPorTaxa(taxaIdealCadastrada: TaxaIdeal): void {
    const controlNameValorIdealComTipo: string = `fl_ideal_${taxaIdealCadastrada.en_tipo}`;
    const controlNameValorMinimoAceitavelComTipo: string = `fl_minimo_aceitavel_${taxaIdealCadastrada.en_tipo}`;

    this.formularioTaxaIdeal.get(controlNameValorIdealComTipo)?.setValue(taxaIdealCadastrada?.fl_ideal);
    this.formularioTaxaIdeal.get(controlNameValorMinimoAceitavelComTipo)?.setValue(taxaIdealCadastrada?.fl_minimo_aceitavel);
  }

  public buscarOperacoesDisponiveis(): void {
    this.loadingOperacoes = true;
    this.loadingTaxas = true;
    this.clienteService.buscarOperacoesDisponiveis(this.clienteId)
      .subscribe(
        (operacoesDisponiveis) => {
          this.loadingOperacoes = false;
          this.loadingTaxas = false;
          if (operacoesDisponiveis) {
            this.operacoesDisponiveis = operacoesDisponiveis.filter(item => !item.temTodasAsTaxas);
            this.formularioTaxaIdeal.get('fk_operacao')?.setValue(this.operacoesDisponiveis[0].sr_id);
            this.filtrarTaxasJaCadastradas(this.operacoesDisponiveis[0].taxas_ideais);
          }
        }
      );
  }

  public atualizarEstadoBotaoSubmit(): void {
    this.formularioTaxaIdeal.valueChanges.subscribe(() => {
      this.botaoDesabilitado = this.deveDesabilitarBotaoFormulario();
    });
  }

  public deveDesabilitarBotaoFormulario(): boolean {
    return this.pesoMinimoMaiorQuePesoMaximo() || this.formularioTaxaIdeal.invalid || !this.formularioFoiAtualizado()
  }

  public formularioFoiAtualizado(): boolean {
    if (!this.operacaoId) {
      return true;
    }

    const VALORES_ATUAIS_FORMULARIO: any = JSON.parse(JSON.stringify(this.formularioTaxaIdeal.getRawValue()));

    return Formulario.foiAlterado(this.valoresIniciais, VALORES_ATUAIS_FORMULARIO);
  }

  public atualizarTaxasSelecionadas(taxasSelecionadas: string[]): void {
    const tiposTaxasSelecionadosAntes: string[] = this.tiposTaxasSelecionados;
    this.tiposTaxasSelecionados = taxasSelecionadas.length > 0 ? taxasSelecionadas : [];

    const tiposTaxasRemovidos: string[] = tiposTaxasSelecionadosAntes.filter((tipoTaxaSelecionadoAntes) => !this.tiposTaxasSelecionados.includes(tipoTaxaSelecionadoAntes));
    const tiposTaxasAdicionados: string[] = this.tiposTaxasSelecionados.filter((tipoTaxaSelecionadoAntes) => !tiposTaxasSelecionadosAntes.includes(tipoTaxaSelecionadoAntes));

    tiposTaxasAdicionados.forEach((tipoTaxaAdicionado: string) => {
      const taxaSelecionada: TaxaDisponivel | undefined =
        this.taxasDisponiveis.find(t => t.tipo === tipoTaxaAdicionado);

      let valoresTaxa = {
        fl_ideal: undefined as number | undefined,
        fl_minimo_aceitavel: undefined as number | undefined
      };

      if (taxaSelecionada) {
        this.taxasSelecionadas.push(taxaSelecionada);
      }

      if (this.taxasIdeaisCadastradas) {
        const taxaCadastrada = this.taxasIdeaisCadastradas.find(
          t => t.en_tipo === tipoTaxaAdicionado
        );

        valoresTaxa = {
          fl_ideal: taxaCadastrada?.fl_ideal,
          fl_minimo_aceitavel: taxaCadastrada?.fl_minimo_aceitavel
        };
      }

      this.adicionarNoFormulario(`fl_ideal_${tipoTaxaAdicionado}`, valoresTaxa.fl_ideal);
      this.adicionarNoFormulario(`fl_minimo_aceitavel_${tipoTaxaAdicionado}`, valoresTaxa.fl_minimo_aceitavel);
    });

    tiposTaxasRemovidos.forEach((tipoTaxaRemovido: string) => {
      this.removerCampoDoFormulario(`fl_ideal_${tipoTaxaRemovido}`);
      this.removerCampoDoFormulario(`fl_minimo_aceitavel_${tipoTaxaRemovido}`);

      this.taxasSelecionadas = this.taxasSelecionadas.filter((taxaSelecionada) => taxaSelecionada.tipo !== tipoTaxaRemovido);
    });

    if (!this.valoresIniciais) {
      this.valoresIniciais = JSON.parse(JSON.stringify(this.formularioTaxaIdeal.getRawValue()))
    }
  }

  public atualizarCamposFormulario(): void {
    let tiposTaxasSelecionadas: any[] = this.taxasSelecionadas.map((taxaSelecionada: any) => taxaSelecionada.tipo);
    let tiposTaxasDisponiveis: any[] = this.taxasDisponiveis.map(taxaDisponivel => taxaDisponivel.tipo);

    tiposTaxasDisponiveis.forEach((tipoTaxaDisponivel: any) => {
      if (tiposTaxasSelecionadas.includes(tipoTaxaDisponivel)) {
        if (this.operacaoId) {
          const taxasIdeaisDoTipoAdicionado: TaxaIdeal[] = this.taxasIdeaisCadastradas.filter((taxaIdeal: TaxaIdeal) => taxaIdeal.en_tipo == tipoTaxaDisponivel);

          this.adicionarNoFormulario(`fl_ideal_${tipoTaxaDisponivel}`)
          this.adicionarNoFormulario(`fl_minimo_aceitavel_${tipoTaxaDisponivel}`)
          this.atualizarValoresIdeaisEMinimosDosTiposCadastrados(taxasIdeaisDoTipoAdicionado);
        }
      } else {
        this.removerCampoDoFormulario(`fl_ideal_${tipoTaxaDisponivel}`)
        this.removerCampoDoFormulario(`fl_minimo_aceitavel_${tipoTaxaDisponivel}`)
      }
    });
  }

  public adicionarNoFormulario(nomeCampo: string, valorCampo?: number | string): void {
    this.formularioTaxaIdeal.addControl(
      nomeCampo,
      this.formBuilder.control(valorCampo || '', Validators.required)
    );
  }

  public removerCampoDoFormulario(nomeCampo: string): void {
    this.formularioTaxaIdeal.removeControl(nomeCampo);
  }

  public atualizarTaxasOperacao() {
    let idOperacao: number = this.formularioTaxaIdeal.get('fk_operacao')?.value

    if (this.operacoesDisponiveis) {
      let operacaoAtual: any = this.operacoesDisponiveis.find(operacao => operacao.sr_id == idOperacao)!;
      this.formularioTaxaIdeal.get('taxas_selecionadas')?.setValue('');
      this.filtrarTaxasJaCadastradas(operacaoAtual.taxas_ideais.length > 0 ? operacaoAtual.taxas_ideais : this.taxasIdeaisCadastradas)
      this.atualizarCamposFormulario();
    }
  }

  public atualizarTaxasOperacaoEdicao(operacaoId: string) {
    this.operacaoId = operacaoId;
    this.formularioTaxaIdeal.get('taxas_selecionadas')?.setValue('');
    this.valoresIniciais = null;

    this.buscarTaxasIdeais();
  }

  public pesoMinimoMaiorQuePesoMaximo(): boolean {
    let invalido: boolean = false;
    this.taxasSelecionadas.forEach((taxaSelecionada, indice) => {
      const pesoMaximo: number = this.formularioTaxaIdeal.get(`fl_ideal_${taxaSelecionada.tipo}`)?.value;
      const pesoMinimo: number = this.formularioTaxaIdeal.get(`fl_minimo_aceitavel_${taxaSelecionada.tipo}`)?.value;
      let minimoMaiorMaximo: boolean = pesoMinimo > pesoMaximo
      this.taxasSelecionadas[indice].erro = minimoMaiorMaximo;

      invalido = invalido || minimoMaiorMaximo;
    });
    return invalido;
  }

  public obterOperacaoIdDaRota(): void {
    this.operacaoId = this.route.snapshot.paramMap.get('id');
  }

  public buscarItensCliente(): void {
    this.clienteId = this.formularioTaxaIdeal.get('fk_cliente')?.value;

    this.formularioTaxaIdeal.get('fk_operacao')?.setValue('');
    this.formularioTaxaIdeal.get('taxas_selecionadas')?.setValue('');

    this.operacoesDisponiveis = null;
    this.taxasOperacao = [...this.taxasSelect];
    this.taxasIdeaisCadastradas = [];

    this.tiposTaxasSelecionados.forEach((tipo: string) => {
      this.removerCampoDoFormulario(`fl_ideal_${tipo}`);
      this.removerCampoDoFormulario(`fl_minimo_aceitavel_${tipo}`);
    });

    this.taxasSelecionadas = [];
    this.tiposTaxasSelecionados = [];

    if (!this.operacaoId) {
      this.buscarOperacoesDisponiveis();
    } else {
      this.buscarOperacoes();
    }
  }

  public cadastrar(): void {
    const taxasSelecionadas: any[] = this.taxasSelecionadas.map((taxaSelecionada: any) => taxaSelecionada.tipo);
    const operacaoId: number = this.formularioTaxaIdeal.get('fk_operacao')?.value;
    const taxaIdeais: TaxasIdeais = taxasSelecionadas.map(taxaIdeal => {
      const pesoMinimo = this.formularioTaxaIdeal.get(`fl_minimo_aceitavel_${taxaIdeal}`)?.value;
      const pesoIdeal = this.formularioTaxaIdeal.get(`fl_ideal_${taxaIdeal}`)?.value;

      return {
        en_tipo: taxaIdeal,
        fl_ideal: pesoIdeal,
        fl_minimo_aceitavel: pesoMinimo
      } as TaxaIdeal;
    });

    const objetoRequest = { taxas: taxaIdeais };

    this.taxaIdealService.cadastrar(objetoRequest, operacaoId)
      .pipe(finalize(() => this.loadingBotao = false))
      .subscribe({
        next: () => {
          this.dialogService
            .sucesso(
              this.translocoService.translate('COMPONENTS.TAXAS_MAPA_FORM.dialogs.createSuccessTitle'),
              this.translocoService.translate('COMPONENTS.TAXAS_MAPA_FORM.dialogs.createSuccessMessage')
            )
            .then(() => this.cancelar());
        },
        error: () => {
          this.dialogService.erro(
            this.translocoService.translate('COMPONENTS.TAXAS_MAPA_FORM.dialogs.createErrorTitle'),
            this.translocoService.translate('COMPONENTS.TAXAS_MAPA_FORM.dialogs.genericErrorMessage')
          );
        }
      });
  }

  public atualizar(): void {
    const taxasIdeais: TaxasIdeais = this.tiposTaxasSelecionados.map(taxaIdeal => {
      const pesoMinimo = this.formularioTaxaIdeal.get(`fl_minimo_aceitavel_${taxaIdeal}`)?.value;
      const pesoIdeal = this.formularioTaxaIdeal.get(`fl_ideal_${taxaIdeal}`)?.value;

      return {
        en_tipo: taxaIdeal,
        fl_ideal: pesoIdeal,
        fl_minimo_aceitavel: pesoMinimo,
        sr_id:
          this.taxasIdeaisCadastradas.find(
            (taxaIdealCadastrada: TaxaIdeal) =>
              taxaIdealCadastrada.en_tipo === taxaIdeal
          )?.sr_id ?? null
      } as TaxaIdeal;
    });

    const objetoRequest = { taxas: taxasIdeais };

    this.taxaIdealService.atualizar(objetoRequest, Number(this.operacaoId))
      .pipe(finalize(() => this.loadingBotao = false))
      .subscribe({
        next: async () => {
          await this.dialogService.sucesso(
            this.translocoService.translate('COMPONENTS.TAXAS_MAPA_FORM.dialogs.updateSuccessTitle'),
            this.translocoService.translate('COMPONENTS.TAXAS_MAPA_FORM.dialogs.updateSuccessMessage')
          );
          this.cancelar();
        },
        error: () => {
          this.dialogService.erro(
            this.translocoService.translate('COMPONENTS.TAXAS_MAPA_FORM.dialogs.updateErrorTitle'),
            this.translocoService.translate('COMPONENTS.TAXAS_MAPA_FORM.dialogs.genericErrorMessage')
          );
        }
      });
  }

  public cancelar(): void {
    this.router.navigate(['/premoplan/taxas-ideais'])
  }
}

